import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  getProyectoLabel,
  getUsuarioNombre,
} from "../usuariosProyectosUtils";

const QuitarUsuarioDialog = ({
  open,
  project,
  user,
  loading = false,
  error = "",
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
    <DialogTitle>Quitar usuario del proyecto</DialogTitle>
    <DialogContent>
      <Typography sx={{ mb: 2 }}>
        ¿Deseas quitar a <strong>{getUsuarioNombre(user)}</strong> del proyecto{" "}
        <strong>{getProyectoLabel(project)}</strong>?
      </Typography>
      <Typography variant="body2" color="text.secondary">
        El usuario perderá el acceso asociado a este proyecto. Su cuenta y sus datos históricos no se eliminarán.
      </Typography>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>Cancelar</Button>
      <Button variant="contained" color="error" onClick={onConfirm} disabled={loading}>
        {loading ? "Quitando..." : "Quitar del proyecto"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default QuitarUsuarioDialog;
